export * from './BagBriefcaseIcon';
export * from './BagBriefcaseIcon16Light';
export * from './BagBriefcaseIcon16Regular';
export * from './BagBriefcaseIcon16Solid';
export * from './BagBriefcaseIcon20Light';
export * from './BagBriefcaseIcon20Regular';
export * from './BagBriefcaseIcon20Solid';
export * from './BagBriefcaseIcon24Regular';
export * from './BagBriefcaseIcon24Solid';
export * from './BagBriefcaseIcon32Regular';
export * from './BagBriefcaseIcon64Regular';
